/* src/app/components/ortho/ortho-home-image/ortho-home-image.component.scss */
/*# sourceMappingURL=ortho-home-image.component.css.map */
